import { LocalStorageKeys } from '@/app/localStorage/types.ts';

export function getURLSearchParams() {
  const params = new URLSearchParams(window.location.search);
  const hash = params.get('hash');

  return {
    hash,
  };
}

export function saveURLSearchParams() {
  const { hash } = getURLSearchParams();

  if (hash) {
    localStorage.setItem(LocalStorageKeys.Hash, hash);
  }
}
